var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 -2.6575 159.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m144.23 1558.3c1.5938-1.5001 2.3438-3.2813 2.3438-5.3438 0-2.8125-3.4688-6.5625-39.656-42.656-36.844-36.938-39.844-39.656-42.844-39.656-2.9063 0-4.7813 1.5001-20.344 17.156-15.281 15.187-17.156 17.438-17.156 20.156 0 4.1249 3.5625 7.6874 7.5938 7.6874 2.625 0 4.7812-1.6875 16.5-13.312l13.406-13.312 35.906 35.812c32.531 32.531 36.187 35.812 38.906 35.812 2.0625 0 3.8438-0.8438 5.3438-2.3437z",
    fill: "#fff",
    strokeWidth: 0.70312
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.824f15dedcf40b4dff0aa96c2bb2ae6e.svg";
export { ForwardRef as ReactComponent };